const PGAdapter = require('../../common/pg-adapter')

const LOCATION_SERVICE_TABLE_NAME = 'avocado.data_location_service'
const LOCATION_SERVICE_COLUMNS = [
  'id',
  'location_id',
  'service_id',
  'site_id',
  'start_date',
  'end_date',
  'funder_fsid',
  'implementing_partner_fsid',
  'created_at',
  'updated_at'
]

class LocationServicePgAdapter extends PGAdapter {
  constructor ({pgConnection, logger, username}) {
    super(pgConnection,
      LOCATION_SERVICE_TABLE_NAME,
      username,
      LOCATION_SERVICE_COLUMNS,
      'id',
      {},
      logger
    )
  }

  async deleteAll (locationUuid, serviceUuid, client = this.pgConnection) {
    const query = `
      DELETE FROM ${LOCATION_SERVICE_TABLE_NAME}
      WHERE location_id = $1 AND service_id = $2
    `
    return client.query(query, [locationUuid, serviceUuid])
  }

  async upsert (locationUuid, serviceUuid, locationServiceData) {
    const pgConnection = this.pgConnection
    const isPool = typeof pgConnection.idleCount === 'number'

    let client
    if (isPool) {
      client = await pgConnection.connect()
    } else {
      client = pgConnection
    }

    try {
      if (isPool) {
        await client.query('BEGIN')
      }

      await this.deleteAll(locationUuid, serviceUuid, client)

      const funders = locationServiceData.funders || []

      let result
      // This is an edge case where a location-service has a funders array but it's empty.
      // Currently there are no such locations on the platform, but since there is no validation and it's technically possible,
      // this code lays out the logic for what to do in that case.
      if (funders.length === 0) {
        const locationService = {
          location_id: locationUuid,
          service_id: serviceUuid,
          site_id: locationServiceData.site_id,
          start_date: null,
          end_date: null,
          funder_fsid: null,
          implementing_partner_fsid: null,
          created_at: locationServiceData.created_at,
          updated_at: new Date()
        }
        const [row] = await super.bulkCreate([locationService], { client })
        result = row
      } else {
        const locationServices = funders.map(funder => ({
          location_id: locationUuid,
          service_id: serviceUuid,
          site_id: locationServiceData.site_id,
          start_date: funder.startDate,
          end_date: funder.endDate,
          funder_fsid: funder.funderId,
          implementing_partner_fsid: funder.implementingPartnerId,
          created_at: locationServiceData.created_at,
          updated_at: new Date()
        }))
        result = await super.bulkCreate(locationServices, { client })
      }

      if (isPool) {
        await client.query('COMMIT')
      }

      return result
    } catch (error) {
      if (isPool) {
        await client.query('ROLLBACK')
      }
      throw error
    } finally {
      if (isPool) {
        client.release()
      }
    }
  }
}

module.exports = LocationServicePgAdapter
